import { action } from '@ember/object'
import { service } from '@ember/service'
import Controller from '@ember/controller'
import type StudentImportService from 'teacher-ui-client/services/student-import'
import type RouterService from '@ember/routing/router-service'
import type InvalidRoute from 'teacher-ui-client/manage/import/students/invalid/route'

export default class InvalidController extends Controller {
  @service
  studentImport!: StudentImportService

  @service
  router!: RouterService

  declare model: ModelFor<InvalidRoute>

  get subscriptionType() {
    return this.model.subscriptionType
  }

  /**
   * Allows the user to set a file for a new import job, then transitions them to the validation page
   */
  @action
  async selectCsvFile(fileArray: File[]) {
    if (fileArray && fileArray.length > 0) {
      const file = fileArray[0]
      await this.studentImport.setFile(file)
      void this.router.replaceWith('manage.import.students.validate')
    }
  }
}
